import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';

@Component({
  selector: 'app-privacy',
  imports: [],
  templateUrl: './privacy.component.html',
  styleUrl: './privacy.component.css'
})
export class PrivacyComponent implements AfterViewInit {

  ngAfterViewInit(): void {
    document.body.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
